import AssetConfig from './AssetConfig';

export default class VideoConfig extends AssetConfig {
  //
}
